import React from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react'
import { Row } from 'components/common/layout'
import { BtnSize, BtnType, Button } from 'components/common/button'
import { PositionApplicationStore } from 'stores/position-application'
import { POSITION_APPLICATION_STEP } from 'infra/constants'
import { Tag, TagSize, TagType } from 'components/common/tag'
import { useIsDesktopCSR } from 'utils/hooks'

const TAB = ['채용 공고', '기업 정보']

export const PositionApplicationTab: React.FC<{
  store: PositionApplicationStore
}> = observer(({ store }) => {
  return (
    <TabContainer>
      {TAB.map((item, index) => (
        <Button
          key={index}
          size={BtnSize.MEDIUM}
          variant={store.curTab === index ? BtnType.SECONDARY : BtnType.TEXT}
          onClick={() => store.setState('curTab', index)}
        >
          {item}
        </Button>
      ))}
    </TabContainer>
  )
})

export const ApplicationStatusTab: React.FC<{
  store: PositionApplicationStore
}> = observer(({ store }) => {
  const isDesktop = useIsDesktopCSR()
  return (
    <Row>
      {POSITION_APPLICATION_STEP.map((item, step) => (
        <Tab
          key={step}
          variant={step === store.curStep ? TagType.BLUE : TagType.LIGHT_GRAY}
          size={isDesktop ? TagSize.MEDIUM : TagSize.SMALL}
        >
          {item}
        </Tab>
      ))}
    </Row>
  )
})

const TabContainer = styled(Row)`
  z-index: 9999;
  width: 100%;
  gap: 8px;
  background-color: ${(p) => p.theme.color.white1};
  @media ${(p) => p.theme.deviceSize.mobile} {
    position: fixed;
    top: 0;
    left: 0;
    padding: 8px;
  }
`

const Tab = styled(Tag)`
  flex: 1;
  text-align: center;
  clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%, 10% 50%);
`
